export default __webpack_public_path__ + "static/media/mr.22da2dfa.svg";